import React from "react";
import PrimaryButton from "../components/PrimaryButton";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="h-screen w-screen relative flex items-center justify-center">
      <div className="z-50">
        <div className=" text-center text-black text-4xl lg:text-5xl font-bold font-['Inter'] tracking-tight mb-2">Page not found</div>
        <div className="text-center text-[#3c3c43]/90 text-xs lg:text-sm font-normal">Sorry, the page you're looking for doesn't exist</div>
        <div className="text-center text-[#3c3c43]/90 text-xs lg:text-sm font-normal">Please check the URL or go back</div>
        <div className="flex justify-center">
          <PrimaryButton onClick={() => navigate(-1)} label="Go back" className="inline-block px-3 py-1 rounded-3xl mt-5" labelStyle="text-sm" />
        </div>
      </div>
      <div className="absolute left-1/2 top-1/2 transform -translate-y-1/2 -translate-x-1/2 z-10">
        <svg className="w-full md:w-[600px] lg:w-[855px]" height="323" viewBox="0 0 855 323" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            opacity="0.06"
            d="M0 261.289H149.646V316.093H212.671V261.289H251.338V208.464H212.671V4.31885H130.16L0 209.377V261.289ZM150.864 208.464H66.3739V206.028L148.428 76.1732H150.864V208.464Z"
            fill="black"
          />
          <path
            opacity="0.06"
            d="M426.075 322.944C504.475 322.944 551.82 263.268 551.972 160.51C552.124 58.5139 504.171 0.0561523 426.075 0.0561523C347.827 0.0561523 300.33 58.3616 300.178 160.51C299.873 262.964 347.522 322.792 426.075 322.944ZM426.075 268.292C390.3 268.292 367.16 232.365 367.313 160.51C367.465 89.7218 390.452 54.0992 426.075 54.0992C461.545 54.0992 484.685 89.7218 484.685 160.51C484.837 232.365 461.698 268.292 426.075 268.292Z"
            fill="black"
          />
          <path
            opacity="0.06"
            d="M602.829 261.289H752.475V316.093H815.5V261.289H854.167V208.464H815.5V4.31885H732.989L602.829 209.377V261.289ZM753.693 208.464H669.203V206.028L751.257 76.1732H753.693V208.464Z"
            fill="black"
          />
        </svg>
      </div>
    </div>
  );
};

export default NotFound;